import { JsonStorageCache } from './json-storage-cache';
const KEY_LAST_COMMENT_SCOPE = 'WS:LastCommentScope';
/**
 * Retrieves the last comment scope from the local storage.
 * @returns The last comment scope.
 */
export function getLastCommentScope() {
    const storage = new JsonStorageCache(localStorage);
    return storage.get(KEY_LAST_COMMENT_SCOPE);
}
/**
 * Sets the last comment scope.
 *
 * @param {CommentScope} scope - The comment scope to set.
 */
export function setLastCommentScope(scope) {
    const storage = new JsonStorageCache(localStorage);
    storage.set(KEY_LAST_COMMENT_SCOPE, scope);
}
